// cspell:  ignore Artilce
import type { FunctionComponent } from "react";
import { useEffect, useState } from "react";
import { graphql, useFragment } from "react-relay";

import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import { useIntersection } from "~/lib/hooks";
import type { appButtonContent$key } from "~/queries/__generated__/appButtonContent.graphql";

import { StyledButton, StyledSmartphoneIcon } from "./styles";

type Props = {
  reference: appButtonContent$key;
};

export const AppButton: FunctionComponent<Props> = ({ reference, ...attribs }) => {
  const content = useFragment(
    graphql`
      fragment appButtonContent on Content {
        urlAlias
      }
    `,
    reference,
  );

  const { captureIntersectionElement, intersection } = useIntersection({
    threshold: 0.45,
  });

  const [isSendImpression, setIsSendImpression] = useState(false);

  useEffect(() => {
    if (!intersection?.isIntersecting || isSendImpression) return;
    sendGATracking({
      action: "App Download/Read Full Artilce/Impression",
      category: "App Download",
      label: window.location.href,
    });
    setIsSendImpression(true);
  }, [intersection, isSendImpression]);

  return (
    <StyledButton
      ref={captureIntersectionElement}
      noStyle
      {...attribs}
      onClick={() => {
        const oneLinkArticle = new URL("https://scmp.onelink.me/3586748601/11c774a");
        oneLinkArticle.searchParams.set("deep_link_value", content.urlAlias);
        sendGATracking({
          action: "App Download/Read Full Artilce/Click",
          category: "App Download",
          label: window.location.href,
        });
        window.location.href = oneLinkArticle.toString();
      }}
    >
      App
      <StyledSmartphoneIcon />
    </StyledButton>
  );
};

AppButton.displayName = "AppButton";
